import { connect } from 'react-redux';
import { savePreference } from '../actions/preferences';
import { DOCK_POSITION } from '../constants/preferences';
import WorkAreaPanel from '../components/Engineering/WorkAreaPanel';

const mapStateToProps = (state) => {
  // check to see if any work area is loading.  if the unity content is loading, treat it the same
  let anyLoading = state.unity.loading;
  const workAreas = state.engineering.workAreas;
  if (!anyLoading) {
    for (let key in workAreas) {
      if (workAreas.hasOwnProperty(key) && workAreas[key].loading === true) {
        anyLoading = true;
        break;
      }
    }
  }

  const alldata = Object.keys(state.engineering.workAreas).reduce(function (
    result,
    key
  ) {
    return { ...result, ...state.engineering.workAreas[key].inputs };
  },
  {});

  return {
    position: state.preferences[DOCK_POSITION],
    workAreas: state.engineering.workAreas,
    nodes: state.engineering.nodes,
    alldata,
    anyLoading,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setDockPosition: (position) => {
      dispatch(savePreference(DOCK_POSITION, position));
    },
  };
};

const EngineeringWorkAreas = connect(
  mapStateToProps,
  mapDispatchToProps
)(WorkAreaPanel);

export default EngineeringWorkAreas;
